<template>
  <div class="t-move-to-dialog">

    <!-- HEADER -->
    <div class="t-move-to-dialog-header">
      <TText value="Move" size="20" font_weight="400" />
      <TText :text="item.name" size="20" font_weight="400" />
    </div>
    
    <!-- SUB HEADER -->
    <div class="t-move-to-dialog-header" v-if="current_folder">
      <TText value="Current Folder:" size="14" font_weight="300" />
      <TText :text="current_folder.name" size="14" font_weight="300" />
    </div>
    
    <!-- ACTIVE FOLDER -->
    <div class="t-move-to-dialog-header mt-4">
      <TBreadcrumbs 
        :breadcrumbs="breadcrumbs" 
        root_name="Home"
        :is_root="active_folder.id === -1"
        :current_folder_name="active_folder.name"
        @clickRoot="changeDir({id: -1, name: 'Home'})"
        @clickBreadcrumb="changeDir($event)" 
      />
    </div>

    <div class="t-move-to-dialog-divider"></div>
    
    <!-- FOLDERS -->
    <div class="t-move-to-dialog-folders">
      
      <div class="t-move-to-dialog-folder-item" v-for="folder in active_folder.folders" :key="`iter-folder-${folder.id}`" @dblclick="changeDir(folder, folder.id === item.id)" :style="folder.id !== item.id ? 'cursor:pointer': ''">
        <div class="t-move-to-dialog-folder-item-left">
          <TIcon name="folder" size="24" />
          <TText :text="folder.name" size="14" />
        </div>
        <div class="t-move-to-dialog-folder-item-right">

          <ButtonOutlined
            text="Move"
            color="#fff"
            height="24"
            :is_disabled="folder.id === current_folder.id || folder.id === item.id"
            @buttonClicked="move(folder)"
          />

          <TIcon name="chevron-right" size="24" @click.native="changeDir(folder, folder.id === item.id)" color="#fff" :is_disabled="folder.id === item.id" />
        </div>
      </div>

    </div>
    
    <div class="t-move-to-dialog-divider"></div>
    
    <!-- BUTTONS -->
    <div class="t-move-to-dialog-buttons">
      <ButtonOutlined
          text="Cancel"
          color="#fff"
          height="24"
          @buttonClicked="cancel()"
        />
      <ButtonOutlined
          text="Move"
          color="#fff"
          height="24"
          :is_disabled="(active_folder.id === current_folder.id) || ( active_folder.id === -1 && current_folder.id === 'last-updated' )"
          @buttonClicked="move(active_folder)"
        />
    </div>
  </div>
</template>
<script>
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import TBreadcrumbs from '@/components/Taktify/TBreadcrumbs.component.vue';
  import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
  import { mapGetters } from 'vuex';
  export default {
    props: ['folders', 'current_folder', 'item', 'item_type', 'folder_type'],
    components: {
      TIcon,
      TBreadcrumbs,
      ButtonOutlined,
    },
    data: () => ({
      active_folder: {
        name: 'Home',
        id: -1,
        folders: []
      }
    }),
    created(){
      this.fillChildFolderElementsForHomeFolder()
    },
    computed: {
      ...mapGetters('WorkBench', [
        'getParentFolders',
        'getWBObject',
      ]),
      breadcrumbs(){
        let breadcrumbs = [];
        if(this.active_folder.id !== -1){
          const wb_object = this.getWBObject({type: this.folder_type + 's', id: this.active_folder.id});
          breadcrumbs = this.getParentFolders({type: this.folder_type, wb_object: wb_object}).reverse();
        }
        // breadcrumbs.push({ name: this.active_folder.name, id: this.active_folder.id })
        return breadcrumbs;
      },
    },
    methods: {
      fillChildFolderElementsForHomeFolder(){
        this.active_folder.folders = [];
        for (let index = 0; index < this.folders.length; index++) {
          if (this.folders[index][this.folder_type] === null) {
            this.active_folder.folders.push(this.folders[index]);
          }
        }
      },
      fillChildFolderElements(folder){
        this.active_folder.folders = [];
        for (let index = 0; index < this.folders.length; index++) {
          if (this.folders[index][this.folder_type] !== null && this.folders[index][this.folder_type].id === folder.id) {
            this.active_folder.folders.push(this.folders[index]);
          }
        }
      },
      changeDir(folder, disabled){
        if(disabled) return;
        this.active_folder.name = folder.name;
        this.active_folder.id = folder.id;
        if (folder.id === -1) {
          this.fillChildFolderElementsForHomeFolder();
        } else {
          this.fillChildFolderElements(folder);
        }
      },
      cancel(){
        this.$emit('cancel')
      },
      move(new_parent){
        this.$emit('move', {
          target: this.item,
          new_parent: new_parent
        })
      }
    }
  }
</script>
<style>

  .t-move-to-dialog {
    position: fixed;
    width: 40%;
    height: 50%;

    left: 30%;
    top: 25%;

    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    z-index: 1000;
    padding: 16px 0px;

    display: flex;
    flex-direction: column;
  }

  .t-move-to-dialog-header {
    display: flex;
    grid-gap: 4px;
    margin: 0px 16px;
  }

  .t-move-to-dialog-divider {
    height: 1px;
    width: 100%;
    background: rgba(255, 255, 255, 0.2);
    margin: 8px 0px;
  }

  .t-move-to-dialog-folders {
    display: flex;
    flex-direction: column;
    height: 60%;
    overflow-y: auto;
  }

  .t-move-to-dialog-folder-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
    padding: 4px 16px;
  }

  .t-move-to-dialog-folder-item:hover {
    background-color: #888;
  }

  .t-move-to-dialog-folder-item:hover .t-move-to-dialog-folder-item-right {
    display: flex;
  }

  .t-move-to-dialog-folder-item-left {
    display: flex; 
    grid-gap: 4px;
    align-items: center;
  }

  .t-move-to-dialog-folder-item-right {
    display: none; 
    align-items: center;
  }

  .t-move-to-dialog-buttons {
    display: flex;
    margin: 0px 16px;
    justify-content: flex-end;
    grid-gap: 8px;
  }

 
</style>
